import { render } from "./ProductAttributeListComponent.vue?vue&type=template&id=6ad194e1"
import script from "./ProductAttributeListComponent.vue?vue&type=script&lang=js"
export * from "./ProductAttributeListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductAttribute/ProductAttributeListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ad194e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ad194e1', __exports__)) {
    api.reload('6ad194e1', __exports__)
  }
  
  module.hot.accept("./ProductAttributeListComponent.vue?vue&type=template&id=6ad194e1", () => {
    api.rerender('6ad194e1', render)
  })

}


export default __exports__